import Vue from 'vue';
import {config} from '../api';
import moment from 'moment'
export default{
  /** 路由跳转
   *  @param {object} ctx 上下文
   *  @param {string} url 路由地址
   *  @param {object} ps 传递参数
   */
  toUrl(ctx, url, ps) {
    ctx.$router.push({path: url, query: ps})
  },
  /** 获取url中的参数
   *  @return {object} 返回对象
   */
  getUrlParams(){
    let search = window.location.search,
      rq = {};
    if (search.indexOf("?") != -1) {
      let str = decodeFromGb2312(search.substr(1));
      let strs = str.split("&");
      let arr = null;
      for (let i in strs) {
        arr = strs[i].split("=");
        rq[arr[0]] = decodeFromGb2312(arr[1])
      }
    }
    return rq;
  },
  isNumber(val){
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if(regPos.test(val) && regNeg.test(val)){
        return true;
    }else{
        return false;
    }
  },
  /** 新增&&修改本地缓存
   *  @param {string} id 唯一id
   *  @param {string} key 标示
   *  @param {string} value 新增&修改的值
   */
  saveLocal (key, value, isStorage){
    key = config.signKey + key;
    value = this.filterNull(value);
    if (isStorage) {
      if (typeof value == 'object') {
        window.localStorage[key] = JSON.stringify(value || {});
      } else {
        window.localStorage[key] = value;
      }

    } else {
      let expireDate = new Date();
      expireDate.setTime(expireDate.getTime()+3600*3600*60*1000);
      // if (!value) {
      //   expireDate.setDate(expireDate.getDate() - 2)
      // }
      if (typeof value == 'object') {
        document.cookie = key + "=" + JSON.stringify(value) + (";expires=" + expireDate)
      } else {
        document.cookie = key + "=" + value + (";expires=" + expireDate)
      }
    }

    // window.localStorage[key] = encodeURIComponent(JSON.stringify(value));
  },
  /** 查询本地缓存
   *  @param {string} id 唯一id
   *  @param {string} key 标示
   *  @param {string} def 如果查询不到显示的值
   */
  loadLocal (key, def, isStorage) {
    key = config.signKey + key;
    let value;
    if (isStorage) {
      value = window.localStorage[key] ? JSON.parse(window.localStorage[key]) : ''
      return value || def
    } else {
      if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(key + "=")
        if (c_start != -1) {
          c_start = c_start + key.length + 1
          let c_end = document.cookie.indexOf(";", c_start)
          if (c_end == -1) c_end = document.cookie.length
          value = JSON.parse(document.cookie.substring(c_start, c_end))
          return value
        }
      }
      return def
    }

    // if (!window.localStorage[key]) {
    //   return def;
    // }
    // let ret = decodeURIComponent(window.localStorage[key]);
    // return ret != 'undefined' ? JSON.parse(ret) : def;
  },
  //读取cookie
  loadLocal2 (key) {
		let keys = config.signKey + key;
		var arr,reg=new RegExp("(^| )"+keys+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg)){
            return unescape(arr[2]);
        }else{
            return null;
        }
	},
  /** 获取当前城市 **/
  getLocation() {
    return new Promise((resolve, reject) => {
      const geolocation = new BMap.Geolocation();
      const gc = new BMap.Geocoder();
      geolocation.getCurrentPosition(res => {
        if (geolocation.getStatus() == BMAP_STATUS_SUCCESS) {
          let pt = res.point;
          gc.getLocation(pt, (rs) => {
            var addComp = rs.addressComponents;
            resolve(addComp);
          });
        } else {
          reject('位置结果未知 获取位置失败.')
        }
      });
    });
  },
  /** 格式化时间
   *  @param {string} date 需要格式化的时间
   *  @param {string} fmt 想要格式化的格式
   */
  formatDate(date, fmt) {
    if (!date) {
      date = new Date();
    }
    function padLeftZero(str) {
      return ('00' + str).substr(str.length)
    }

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
      }
    }
    return fmt;
  },
  formatDate1(value) {
    return moment(String(value),'DD/MM/YYYY' ).format('DD MMM YYYY')
  },
  /** 格式化时间，返回年，月，日
   *  @param {string } date 需要格式化的时间
   */
  objectDate(date) {
    if (date && typeof date === 'string') {
      date = new Date(date);
      let o = {
        'Y': date.getFullYear(),
        'M': date.getMonth() + 1,
        'D': date.getDate()
      };
      return o;
    }
    return date;
  },
  /** 格式化时间，返回时间差，年，月，日
   * @param {string} date 开始日期字符串
   * @param {string} endDate 结束日期字符串
   * @param {Number} i 第几类 0秒，1分钟，2小时，3天，4月，5年
   * @param {Boolean} isUnit 是否输出单位
   * */
  time2Diff (date, endDate, i, isUnit){
    // 开始时间
    let startTime = {}
    if (date)
      startTime = new Date(date);
    else {
      startTime = new Date();
    }
    // 结束时间
    let endTime = {};
    if (endDate) {
      endTime = new Date(endDate)
    } else {
      endTime = new Date();
    }
    startTime.setHours(0)
    startTime.setMinutes(0)
    startTime.setSeconds(0)
    endTime.setHours(0)
    endTime.setMinutes(0)
    endTime.setSeconds(0)
    // 时间差的毫秒数
    let timeDifferent = endTime.getTime() - startTime.getTime();

    function filter(value, index) {
      if (i == undefined) {
        return compare(value, index) ? filter(compare(value, index), (index + 1)) : describe(value, index);
      } else {
        return (compare(value, index) && index < i) ? filter(compare(value, index), (index + 1)) : describe(value, index);
      }
    }

    function compare(value, index) {
      switch (index) {
        case 0:
          return (value / 60).toFixed(0);
        case 1:
          return (value / 60).toFixed(0);
        case 2:
          return (value / 24).toFixed(0);
        case 3:
          return (value / 30).toFixed(0);
        case 4:
          return (value / 12).toFixed(0)
      }
    }
    function describe(value, index) {
      switch (index) {
        case 0:
          return isUnit ? (value + '秒前') : Number(value);
        case 1:
          return isUnit ? (value + '分钟前') : Number(value);
        case 2:
          return isUnit ? (value + '小时前') : Number(value);
        case 3:
          return isUnit ? (value + '天前') : Number(value);
        case 4:
          return isUnit ? (value + '月前') : Number(value);
        case 5:
          return isUnit ? (value + '年前') : Number(value);
      }
    }

    return filter(timeDifferent / 1000, 0);
  },
  getMonthE(val){
    let arr=['Jan','Fab','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    return arr[val-1]
  },
  /** 格式化时间，返回该日期是星期几
   * @param {string} date 需要格式化的时间
   * */
  timeWeek (date){
    date = new Date(date);
    if (date.getDay() == 0) return "日"
    if (date.getDay() == 1) return "一"
    if (date.getDay() == 2) return "二"
    if (date.getDay() == 3) return "三"
    if (date.getDay() == 4) return "四"
    if (date.getDay() == 5) return "五"
    if (date.getDay() == 6) return "六"
  },
  /** 格式化时间，返回该日期是星期几
   * @param {Number} count 天数
   * @param {String} placeholder 占位符
   * */
  showAfterDate (count, date, placeholder){
    let dd = {};
    if (date) {
      dd = new Date(date)
    } else {
      dd = new Date()
    }
    dd.setDate(dd.getDate() + count);//获取count天后的日期
    let y = dd.getFullYear();
    let m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
    let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
    return y + (placeholder || "-") + m + ( placeholder || "-") + d;
  },
  /** 提示
   *  @param {string} msg 提示消息内容
   */
  getDateTime(cur){
    const datetime = new Promise((resolve, reject) => {
      Vue.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM-DD',
        startDate: '1970-01-01',
        value: cur ? cur : this.formatDate(new Date(), 'yyyy-MM-dd'),
        endDate: this.formatDate(new Date(), 'yyyy-MM-dd'),
        onConfirm (v) {
          resolve(v);
        }
      })
    }).catch(function (err) {
      return false;
    });
    return datetime;
  },
  /** 提示
   *  @param {string} msg 提示消息内容
   */
  toast(msg){
    alert(msg)
  },
  /** 确认提示
   *  @param {string} title 提示标题
   *  @param {string} msg 提示内容
   */
  alert(titles, msg, type){
    Vue.prototype.$message ({
      showClose: true,
      message: msg,
      type: type,
      duration:3000
    })
  },
  /** 带输入框提示
   *  @param {string} title 提示标题
   *  @param {string} value 输入框内容
   */
  prompt(title, value){
    const dialog = new Promise((resolve, reject) => {
      Vue.$vux.confirm.prompt(value, {
        title: title,
        content: msg,
        theme: "android",
        onCancel () {
          resolve();
        },
        onConfirm (msg) {
          resolve(msg);
        }
      })
    }).catch(function (err) {
      return false;
    });
    return dialog;
  },
  /** 加载提示
   *  @param {boolean} isShow 是否显示
   *  @param {string} msg 提示内容
   */
  loading(isShow, msg){
    if (isShow)
      Vue.$vux.loading.show({
        text: msg ? msg : '加载中',
        background: rgba(255, 255, 255, 0.7)
      });
    else
      Vue.$vux.loading.hide();
  },
  loadings(n) {
    Vue.prototype.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.4)',
      target: document.querySelector('body')
    });
    switch (n){
      case 2:
        let loading =Vue.prototype.$loading({});
        loading.close()
        break;
    }
  },
  /** 检查(对象|数组)对应(键|下标)内容为空提示
   *  @param {object,Array} obj 对象|数组
   *  @param {object} key 键|下标
   *  @param {string} msg 提示内容
   */
  validateNull(obj, key, msg){
    if (key.indexOf(Object.keys(obj)) != -1) {
      this.toast(msg ? msg : key + '为空');
      return false;
    } else {
      if (!obj[key]) {
        this.toast(msg ? msg : key + '为空');
        return false;
      }
    }
    return true;
  },
  /** 去除(对象|数组)中为空(null、'null'、undefined，空字符串除外)的字段和下标
   *  @param {object,Array} value 对象|数组
   */
  filterNull(value){
    if (typeof value == 'object') {
      for (let k in value) {
        if (value[k] == null || value[k] == 'null' || value[k] == undefined) {
          if (value.length > 0) {
            value.splice(k, 1)
          } else {
            delete value[k]
          }
        }
      }
    }
    return value
  },
  /** 去除字符串的左右空格
   *  @param {string} value 字符串
   */
  trim(value){
    if (typeof(value) === 'string')
      return value.replace(/(^\s*)|(\s*$)/g, '');
    return value
  },
  /** 数组内容过滤
   *  @param {string} text 过滤包含内容
   *  @param {Array} array 待过滤数组
   *  @param {function} filter 过滤方法
   */
  nativeSearch(text, array, filter){
    let matches = {};
    let promise = new Promise((resolve) => {
      if (!filter) {
        matches = array.filter(function (datas) {
          if (datas.BRXM.indexOf(text) !== -1) return true;
        })
      } else {
        matches = array.filter(filter);
      }
      resolve(matches);
    }).catch((err) => {

    });

    return promise;
  },
  // 格式化时间 时分秒分开（用）
  timestampToTime1(timestamp) {
    let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + ' ';
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + '/';
    //let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <=0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 ==0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM';
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D+M+Y;
  },
     // 格式化时间  传入时间戳，返回年月日/am（用月份为英文带星期）
     timestampToTimeW1(timestamp) {
      let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + ' | ';
      let M=date.toString().split(' ')[1]+' '
      let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
      let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
      let W=moment(date).format('dddd');
      if(H -12 <=0){
          H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
      }else if(H-12>0 && H-24<0){
          H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
      }else if(H-24 ==0){
          H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
      }
      // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
      return W+', '+D+M+Y+H;
    },
   // 格式化时间  传入时间戳，返回年月日/am（用月份为英文）
   timestampToTime(timestamp) {
    let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + ' | ';
    let M=date.toString().split(' ')[1]+' '
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <=0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 ==0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D+M+Y+H;
  },
   // 格式化时间 返回年月（用月份为英文）
   timestampToYear(timestamp) {
    let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '';
    let M=date.toString().split(' ')[1]+' '
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <=0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 ==0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return M+Y;
  },

     getYear(timestamp) {
      let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '';
      return Y
    },

   // 格式化时间 返回月日（用月份为英文）
   timestampToMon(timestamp) {
    let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '';
    let M=date.toString().split(' ')[1]+' '
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <=0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 ==0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D+M;
  },
     // 格式化时间  传入时间戳，返回星期几 年月日（用）
     timestampToTimeWeek(timestamp) {
      let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear();
      let M=date.toString().split(' ')[1]+' '
      let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
      let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
      if(H -12 <=0){
          H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
      }else if(H-12>0 && H-24<0){
          H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
      }else if(H-24 ==0){
          H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
      }
      let W=moment(date).format('dddd');
      // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
      return W+','+D+M+Y;
    },
    // 格式化时间  传入时间戳，返回小时（用）
   timestampToTimeHour(timestamp) {
    let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <=0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 ==0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
    }
    return H;
  },
   // 格式化时间  传入时间戳，返回年月日/am(用)
   timestampToTimes(timestamp) {
    let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '';
    let M=date.toString().split(' ')[1]+' '
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <=0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 ==0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D+M+Y;
  },
  // 格式化时间  传入时间戳，返回年月日/am（用月份为英文）
  timestampToTime2(timestamp) {
    let date = new Date(timestamp*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M=date.toString().split(' ')[1]+' '
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <=0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 ==0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D+M+Y;
  },
  // 格式化时间  传入时间戳，返回年月日/am（用月份为英文）
  timestampToTime3(timestamp) {
    let date = new Date(timestamp*1000);
    let Y = date.getFullYear() + ' ';
    let M=date.toString().split(' ')[1]+' '
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <=0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() <10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 == 0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes())  :  date.getMinutes())+ ' PM';
    }else if(H-12 == 0){
      H ='12' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM';
    }
    return H+' '+D+M+Y;
  },
  timestampToTimeNew(timestamp) {
    let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + '/';
    //let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
    let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours());
    if(H -12 <0){
        H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' AM';
    }else if(H-12>0 && H-24<0){
        H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    }else if(H-24 ==0){
        H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM';
    }else if(H-12 ==0){
      H ='12' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM';
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return H+' '+D+M+Y;
  },
  //获取当前时间
  getNowDate() {
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    // let month=date.toString().split(' ')[1]
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 +strDate;
    return currentdate;
  },
  getNowTime() {
    let date = new Date();
    let H =date.getHours();
    let m =date.getMinutes();
    // if(H -12 <=0){
    //     H = H+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' AM';
    // }else if(H-12>0 && H-24<0){
    //     H = (H - 12) < 10?'0'+(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ' PM':(H - 12)+ ':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) +' PM';
    // }else if(H-24 ==0){
    //     H ='00' +':'+ (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes())+ ' PM';
    // }
    let currentdate = H*60*60*1000;
    let currentdate1 = m*60*1000;
    return currentdate+currentdate1;
  },
  dianTime(timestamp){
    let date = new Date(Number(timestamp));   //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '  ';
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '.';
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + '.';
    return D+M+Y;
  },
  //获取当前月份
  getNowmonth() {
    let date = new Date();
    let seperator1 = "/";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    let currentdate = year + seperator1 + month;
    return currentdate;
  },
  getNowYear() {
    let date = new Date();
    let seperator1 = "/";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    return year;
  },
  //获取月份最后一天和第一天
  getmonthlastday(val) {
    let endDate = new Date(val);
    let month=endDate.getMonth();
    let nextMonth=++month;
    let nextMonthFirstDay=new Date(endDate.getFullYear(),nextMonth,1);
    let oneDay=1000*60*60*24;
    let d = new Date(nextMonthFirstDay-oneDay);
    let datetime = d.getFullYear() + '-' + ((d.getMonth() + 1)<10?'0'+(d.getMonth() + 1):(d.getMonth() + 1))+ '-' + d.getDate()
    let datetimes = d.getFullYear() + '-' +((d.getMonth() + 1)<10?'0'+(d.getMonth() + 1):(d.getMonth() + 1))+ '-' + '01'
    let obi = {
      last: datetime,
      first:datetimes
    }
    return obi;
  },
  //获取昨天日期
  getyestoday() {
    var day1 = new Date();
    let day2 = day1.setTime(day1.getTime()-24*60*60*1000);
    let date = new Date(day2);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
    return Y+M+D;
  },
   //获取7天前日期
   get7yestoday() {
    var day1 = new Date();
    let day2 = day1.setTime(day1.getTime()-24*60*60*1000*7);
    let date = new Date(day2);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
    return Y+M+D;
  },
  //获取30天前日期
  get30yestoday() {
    var day1 = new Date();
    let day2 = day1.setTime(day1.getTime()-24*60*60*1000*30);
    let date = new Date(day2);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
    return Y+M+D;
  },
  getWeek() {
    var date = new Date();
    var today = date.getDay();
    var stepSunDay = -today + 1;
    if (today == 0) {
      stepSunDay = -7;
    }
    var stepMonday = 7 - today;
    var time = date.getTime();
    var monday = new Date(time + stepSunDay * 24 * 3600 * 1000);
    var sunday = new Date(time + stepMonday * 24 * 3600 * 1000);

    function transferDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) { day = "0" + day; }
      var dateString = year + '/' + month + '/' + day;
      return dateString;
    }

    //本周一的日期 （起始日期）
    var startDate = transferDate(monday);
    // 日期变换      //本周日的日期 （结束日期）
    var endDate = transferDate(sunday); // 日期变换
    return startDate , endDate;
  },
  //传入本地时间获得标准时间
  localtime(time,n) {
    var date = new Date(time);
    //var times=d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

    if(n==0) {
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
    }
    return Y+M+D
  },
  localTIMES() {
    var date = new Date();
    var D = date.getHours()
     var m = date.getMinutes()
    return D+':'+m
  },
  getPrice (val) {
    //let check = (Math.ceil(Number(val)) == Number(val)?Number(val)+'.00':Number(val))
    let check = val?val:''
    var arr = check.toString().split('.');
    var l = arr[0], r = '';
    // 判断是否存在小数部分，如果存在才获取
    if (arr.length == 2) {
      r = arr[1];
    }
    // 将整数部分胡成字符串形式并进行反转
    l = l.split('').reverse().join('');
    // 利用正则进行三位添加一逗号的操作 注意在插入逗号的时候存在在最后一位插入逗号的可能
    l = l.replace(/(\d{3})/g,function (m,m1) { return m1 + ','; });
    l = l.split('').reverse().join('');
    // 将字符串反转回去 有可能第一位就是一个逗号 若出现这种现象 舍去首位的逗号
    if (l[0] == ',') {
      l = l.slice(1);
    }
    // 将处理后的整数部分加上小数部分返回
    if(r){
      return l + '.' + r;
    }else{
      return l
    }
  },
  getPrice1(val){
    let check = val?val:''
    check=Math.round(check * 100) / 100
    let pos_decimal =String(check).split('.')
    let check_ = pos_decimal[1]?pos_decimal[1].length:undefined
    let check_2 = pos_decimal[0]?pos_decimal[0]:'0'
    let backtime = ''
    if (check_== undefined) {
      backtime = (check_2+'.00').trim()
    }else if (check_ == 1){
      backtime = pos_decimal.join('.')+'0'
    }else if (check_ == 2){
      backtime = pos_decimal.join('.')
    }else{
      let arr=pos_decimal[1].split('')
      backtime=check_2+'.'+arr[0]+arr[1]
    }
    return String(backtime)
  },
  getTmeing (val) {
    var timestamp2 = Date.parse(new Date(val));
    return  timestamp2
  },
  addERROR(val) {
    let errs = ''
    if (val) {
      if (val.length == 9) {
        errs = '0'+val
      } else {
        errs = val
      }
    }else {
      errs = val
    }
    return errs
  },
  getPhone(number){//格式化手机号码
    if(number){
      let arr=number.split('')
      let str1=''
      let str2=''
      let str3=''
      arr.forEach((item,i)=>{
          if(i==0&&item!==0){
            str1=`+61${item}`
          }
          if(i>0&&i<5){
            str2+=item
          }
          if(i>4&&i<9){
            str3+=item
          }
      })
      return str1+' '+str2+' '+str3
    }
  },
  getABN (key) {
      let num = key.replace(/\s+/g,"")
      if(num.length==9){
        let str1=''
        let str2=''
        let str3=''
        num.split('').forEach((item,i)=>{
            if(i>=0&&i<3){
              str1+=`${item}`
            }
            if(i>=3&&i<6){
              str2+=item
            }
            if(i>=6&&i<9){
              str3+=item
            }
            num=str1+' '+str2+' '+str3
        })
      }else{
        if (num && num.length>2) {
            num = num.split('')
            let num1 = num.splice(0,2).join('')
            let result = []
            let result2 = []
            for(var i=0;i<num.length;i+=3){
                result.push(num.slice(i,i+3));
            }
            result.forEach((fruit)=>{
                result2.push(fruit.join(''))
            })
            num = num1+' '+result2.join(' ')
        }
      }
      return num
  },
  removeRepeatArray  (arr) {
      return arr.filter(function (item, index, self) {
          return self.indexOf(item) === index;
      });
  },
  getMobile(number){//格式化手机号码
    let arr=number.split('')
    let str1=''
    let str2=''
    let str3=''
    let str4=''
    if(number){
      if(number.length==8){
        arr.forEach((item,i)=>{
            if(i>=0&&i<4){
              str1+=`${item}`
            }
            if(i>=4&&i<8){
              str2+=item
            }
        })
        return str1+' '+str2
      }else if(number.length<8){
        return number
      }
      if(number.length==9){
        number=0+number
      }
      arr=number.split('')
      arr.forEach((item,i)=>{
          if(i>=0&&i<4){
            str1+=`${item}`
          }
          if(i>=4&&i<7){
            str2+=item
          }
          if(i>=7&&i<10){
            str3+=item
          }else if(i>=10){
            str4+=item
          }
      })
      return str1+' '+str2+' '+str3+' '+str4
    }
  },
  getNewTime(timeStr){
    let arr = timeStr.split('/');
    return `${arr[2]}/${arr[1]}/${arr[0]}`
  },
  getMobile1(number){//格式化手机号码
    // if(number){
    //   let arr=number.split('')
    //   let str1=''
    //   let str2=''
    //   arr.forEach((item,i)=>{
    //       if(i>=0&&i<4){
    //         str1+=`${item}`
    //       }
    //       if(i>=4&&i<8){
    //         str2+=item
    //       }
    //   })
    //   return str1+' '+str2
    // }
    let arr=number.split('')
    let str1=''
    let str2=''
    let str3=''
    let str4=''
    if(number){
      if(number.length==8){
        arr.forEach((item,i)=>{
            if(i>=0&&i<4){
              str1+=`${item}`
            }
            if(i>=4&&i<8){
              str2+=item
            }
        })
        return str1+' '+str2
      }else if(number.length<8){
        return number
      }
      if(number.length==9){
        number=0+number
      }
      arr=number.split('')
      arr.forEach((item,i)=>{
          if(i>=0&&i<4){
            str1+=`${item}`
          }
          if(i>=4&&i<7){
            str2+=item
          }
          if(i>=7&&i<10){
            str3+=item
          }else if(i>=10){
            str4+=item
          }
      })
      return str1+' '+str2+' '+str3+' '+str4
    }
  },
  isContained (a, b){
    if(!(a instanceof Array) || !(b instanceof Array)) return false;
    if(a.length < b.length) return false;
    var aStr = a.toString();
    for(var i = 0, len = b.length; i < len; i++){
      if(aStr.indexOf(b[i]) == -1) return false;
    }
    return true;
  },
  deteleObject(obj) {
    var uniques = [];
    var stringify = {};
    for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function(a, b) {
            return (Number(a) - Number(b));
        });
        var str = '';
        for (var j = 0; j < keys.length; j++) {
            str += JSON.stringify(keys[j]);
            str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
            uniques.push(obj[i]);
            stringify[str] = true;
        }
    }
    uniques = uniques;
    return uniques;
  },
  getCurrWeekDays(){//获取本周开始结束时间。
    let date = []
    let start = Date.parse(moment().startOf('week').format('YYYY-MM-DD'))/1000
    let end = Date.parse(moment().endOf('week').format('YYYY-MM-DD'))/1000
    date.push(start)
    date.push(end)
    return date
  },
  getLastWeekDays(){// 获取上一周的开始结束时间
      let date = []
      let start = moment().week(moment().week() - 1).startOf('week').format('YYYY-MM-DD')
      let end = moment().week(moment().week() - 1).endOf('week').format('YYYY-MM-DD')
      start=Date.parse(start)/1000
      end=Date.parse(end)/1000
      date.push(start)
      date.push(end)
      return date
  },
  getCurrMonthDays(){//获取本月开始结束时间
      let date = []
      let start = moment().startOf('month').format('YYYY-MM-DD')
      let end = moment().endOf('month').format('YYYY-MM-DD')
      start=Date.parse(start)/1000
      end=Date.parse(end)/1000
      date.push(start)
      date.push(end)
      return date
  },
  getCurrDays(){// 获取当天的开始结束时间，精确到时分秒
      let date = []
      let start=moment().startOf('days').format('YYYY-MM-DD HH:mm:ss')
      let end=moment().endOf('days').format('YYYY-MM-DD HH:mm:ss')
      start=Date.parse(start)/1000
      end=Date.parse(end)/1000
      date.push(start)
      date.push(end)
      return date
  },
  getYesterday(){ // 获取昨天的开始结束时间，精确到时分秒
  let date = []
      let start=moment().subtract('days',1).startOf('days').format('YYYY-MM-DD HH:mm:ss')
      let end=moment().subtract('days',1).endOf('days').format('YYYY-MM-DD HH:mm:ss')
      start=Date.parse(start)/1000
      end=Date.parse(end)/1000
      date.push(start)
      date.push(end)
      return date
  },
  getLast7Days(){// 获取最近七天的开始结束时间
      let date = []
      // 不包含当天
      date.push(Date.parse(moment().subtract('days',7).format('YYYY-MM-DD'))/1000)
      date.push(Date.parse(moment().subtract('days',1).format('YYYY-MM-DD'))/1000)
      // 包含当天
      // date.push(moment().subtract('days',6).format('YYYY-MM-DD'))
      // date.push(moment().format('YYYY-MM-DD'))
      return date
  },
  getLast30Days(){// 获取最近30天的开始结束时间
      let date = []
      date.push(Date.parse(moment().subtract('days',30).format('YYYY-MM-DD'))/1000)
      date.push(Date.parse(moment().subtract('days',1).format('YYYY-MM-DD'))/1000)
      return date
  },
  getLast60Days(){// 获取60天前
      let date=moment().subtract('days',60).format('YYYY-MM-DD')
      console.log(date);

      return date
  },
  formatSplit(s, type) {
    if (s == 0) {
      return "0";
    }
    if (!s) {
      return null
    }
    if (s == null || s == "") {
      return '';
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s))
      s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
    if (type == 0) {// 不带小数位(默认是有小数位)
      var a = s.split(".");
      if (a[1] == "00") {
        s = a[0];
      }
    }
    return s;
  },
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  getActiveType(val,val1){ // 获取当前索引
    let act=''
    if(val1!=undefined){
      if(val1.indexOf('exportInfo?type=1') != -1){
        return 2
      }else if(val1.indexOf('exportInfo?type=2') != -1){
        return 7
      }
      if(val1.indexOf('exportRcti?type=1') != -1){
        return 2
      }else if(val1.indexOf('exportRcti?type=2') != -1){
        return 7
      }
    }
    switch (val) {
      case '/referrer':
        act=1
        break;
      case '/revicedprice':
        act=1
        break;
      case '/referrerdetail':
        act=1
        break;
      case '/commisionD':
        act=1
        break;
      case '/propertyLists':
        act=1
        break;
      case '/createReferrer':
        act=1
        break;
      case '/property':
        act=2
        break;
      case '/propertyDetail':
        act=2
        break;
      case '/addproperty':
        act=2
        break;
      case '/reserveDetail':
        act=2
        break;
      case '/InvoiceStatus':
        act=2
        break;
      case '/addRoom':
        act=2
        break;
      case '/addConstruction':
        act=2
        break;
      case '/addConstruction':
        act=2
        break;

      case '/newproperty/property':
        act=7
        break;
      case '/newproperty/reserve':
        act=7
        break;
      case '/newproperty/propertyDetail':
        act=7
        break;
      case '/newproperty/addproperty':
        act=7
        break;
      case '/newproperty/reserveDetail':
        act=7
        break;
      case '/newproperty/InvoiceStatus':
        act=7
        break;
      case '/newproperty/addRoom':
        act=7
        break;
      case '/newproperty/addConstruction':
        act=7
        break;
      case '/newproperty/addConstruction':
        act=7
        break;
      case '/sharedProperties':
        act=8
        break;
      case '/faqlist':
        act=3
        break;
      case '/newFAQ':
        act=3
        break;
      case '/serviceList':
        act=4
        break;
      case '/addservice':
        act=4
        break;
      case '/serviceTypeList':
        act=4
        break;
      case '/addServiceType':
        act=4
        break;
      case '/settings':
        act=5
        break;
      case '/index' :
        act=16
        break;
      case '/company' :
        act=5
        break;
      case '/advertising' :
        act=9
        break;
      case '/dashboard' :
        act=16
        break;
      case '/agencies' :
      case '/editAgent' :
      case '/addagency' :
        act=12
        break;
      case '/reporting' :
        act=10
        break;
      case '/profile' :
        act=17
        break;
      case '/editProfile' :
        act=17
        break;
      case '/listings' :
      case '/createlisting' :
      case '/viewListing' :
        act=18
        break;
      case '/faqs' :
      case '/faqAgencyList' :
      case '/FaqUNIFIList' :
        act=19
        break;
      case '/agencyprofile' :
        act=20
        break;
      case '/uconnect' :
      case '/editUConnect' :
        act=21
        break;
    }

    return act
  }
}

// 节流
export function throttle(fn, t){
  let last;
  let timer;
  let interval = t || 500;
  return function () {
      let args = arguments;
      let now = +new Date();
      if (last && now - last < interval) {
          clearTimeout(timer);
          timer = setTimeout(() => {
              last = now;
              fn.apply(this, args);
          }, interval);
      } else {
          last = now;
          fn.apply(this, args);
      }
  }
}

// 防抖
export function debounce(fn, delay) {
     var timer = null;
      return function() {
      var args = arguments;
      var that = this;
      clearTimeout(timer)
      timer = setTimeout(function() {
               fn.apply(that,args)
          }, delay)
      }
  }





// WEBPACK FOOTER //
// ./src/untils/index.js